import React, { useEffect, useState } from 'react';
import { Mail, Send, Save } from 'lucide-react';
import toast from 'react-hot-toast';
import api from '../../utils/api';

// Configuración global de canales de notificaciones (super admin)
export default function NotificationChannelsAdmin() {
  const [smtp, setSmtp] = useState({ host: '', port: '587', user: '', pass: '', from: '', test_to: '' });
  const [passSet, setPassSet] = useState(false);
  const [tg, setTg] = useState({ configured: false, username: '' });
  const [tgToken, setTgToken] = useState('');
  const [busy, setBusy] = useState('');

  const load = () => api.get('/admin/notification-channels').then(r => {
    setSmtp(s => ({ ...s, host: r.data.smtp.host, port: r.data.smtp.port, user: r.data.smtp.user, from: r.data.smtp.from, pass: '' }));
    setPassSet(r.data.smtp.pass_set); setTg(r.data.telegram);
  }).catch(() => {});
  useEffect(() => { load(); }, []);

  const saveSmtp = async (e) => {
    e.preventDefault(); setBusy('smtp');
    try { const r = await api.put('/admin/notification-channels/smtp', smtp); toast.success(r.data.message); load(); }
    catch (err) { toast.error(err.response?.data?.error || 'Error', { duration: 8000 }); }
    finally { setBusy(''); }
  };
  const saveTg = async (e) => {
    e.preventDefault(); setBusy('tg');
    try { const r = await api.put('/admin/notification-channels/telegram', { token: tgToken }); toast.success('Bot conectado: @' + r.data.username); setTgToken(''); load(); }
    catch (err) { toast.error(err.response?.data?.error || 'Error', { duration: 8000 }); }
    finally { setBusy(''); }
  };

  const h3 = { fontSize: 16, fontWeight: 700, marginBottom: 6, display: 'flex', alignItems: 'center', gap: 8 };
  const help = { fontSize: 12, color: 'var(--text-muted)', marginBottom: 14, lineHeight: 1.45 };
  const set = (k) => (e) => setSmtp({ ...smtp, [k]: e.target.value });

  return (<>
    <div className="card">
      <h3 style={h3}><Mail size={18} /> Email de notificaciones (SMTP)</h3>
      <p style={help}>Cuenta desde la que se envían los avisos y resúmenes por email a todos los clientes. Con Gmail: servidor smtp.gmail.com, puerto 465 y una "contraseña de aplicación".</p>
      <form onSubmit={saveSmtp}>
        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 10 }}>
          <div className="form-group"><label>Servidor</label><input value={smtp.host} onChange={set('host')} placeholder="smtp.gmail.com" required /></div>
          <div className="form-group"><label>Puerto</label><input value={smtp.port} onChange={set('port')} placeholder="465" /></div>
        </div>
        <div className="form-group"><label>Usuario</label><input value={smtp.user} onChange={set('user')} placeholder="notificaciones@tudominio.com" required /></div>
        <div className="form-group"><label>Contraseña {passSet && <span style={{ color: 'var(--text-muted)' }}>(guardada; completá solo para cambiarla)</span>}</label><input type="password" value={smtp.pass} onChange={set('pass')} required={!passSet} /></div>
        <div className="form-group"><label>Remitente</label><input value={smtp.from} onChange={set('from')} placeholder='Udream App <notificaciones@tudominio.com>' /></div>
        <div className="form-group"><label>Enviar email de prueba a (opcional)</label><input type="email" value={smtp.test_to} onChange={set('test_to')} placeholder="tu@email.com" /></div>
        <button type="submit" className="btn btn-primary" disabled={busy === 'smtp'}><Save size={16} /> {busy === 'smtp' ? 'Guardando...' : 'Guardar'}</button>
      </form>
    </div>
    <div className="card">
      <h3 style={h3}><Send size={18} /> Bot de Telegram</h3>
      <p style={help}>Creá un bot con <b>@BotFather</b> en Telegram (comando /newbot), copiá el token y pegalo acá. Después cada usuario lo conecta desde la campanita → Configurar.</p>
      <div style={{ fontSize: 13, marginBottom: 12 }}>{tg.configured ? <>Bot conectado: <b>@{tg.username}</b></> : <span style={{ color: 'var(--text-muted)' }}>Sin bot configurado</span>}</div>
      <form onSubmit={saveTg}>
        <div className="form-group"><label>{tg.configured ? 'Reemplazar token' : 'Token del bot'}</label><input type="password" value={tgToken} onChange={e => setTgToken(e.target.value)} placeholder="123456789:AA..." required /></div>
        <button type="submit" className="btn btn-primary" disabled={busy === 'tg'}><Save size={16} /> {busy === 'tg' ? 'Conectando...' : 'Conectar bot'}</button>
      </form>
    </div>
  </>);
}
